function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from 'react';
import AgreementStudio from "./AgreementStudio";
import { useStoreActions } from "../../contexts";
import RestfulWrapper from "../RestfulWrapper/RestfulWrapper";
export default function RelationshipDraftFetcher(props) {
  const {
    api
  } = useStoreActions();
  const {
    draftId
  } = props.match.params;
  return /*#__PURE__*/React.createElement(RestfulWrapper, {
    fetch: () => api.draft.getById(draftId),
    renderChild: _ref => {
      let {
        data
      } = _ref;
      return /*#__PURE__*/React.createElement(AgreementStudio, _extends({}, props, {
        relationshipDraft: data
      }));
    }
  });
}